import type { PatientModel } from '@ctw/shared/api/fhir/models/patient';
import type { PatientListItemModel } from '@ctw/shared/api/fhir/models/patient-list-item';
import { useBuilderConfig } from '@ctw/shared/context/builder-config-context';
import { tw, twx } from '@ctw/shared/utils/tailwind';
import { startCase } from 'lodash-es';

type PatientInfoLineProps = {
  patient?: PatientModel | PatientListItemModel;
  className?: string;
};

export function PatientInfoLine({ patient, className }: PatientInfoLineProps) {
  const builderConfig = useBuilderConfig();

  if (!patient) {
    return null;
  }

  const gender = patient.gender ? startCase(patient.gender) : undefined;
  const mrn = patient.findIdentifier(builderConfig.systemMRN);

  return (
    <div className={`${twx(className)} text-content-subtle`}>
      {`${patient.dob} `}
      <span className={tw`block md:inline`}>
        {patient.age !== undefined && <span>({patient.age})</span>}
        {mrn !== undefined && (
          <span>
            ,&nbsp;
            {mrn}
          </span>
        )}
        {gender !== undefined && (
          <span>
            ,&nbsp;
            {gender}
          </span>
        )}
      </span>
    </div>
  );
}
